// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__2_TFh","ProjectsMain":"Projects_ProjectsMain__KTs2_"};